var React = require('react');

function Gg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"}));
}

Gg.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Gg;

Gg.default = Gg;
